import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../../store';

@customElement('page-footer')
export class PageFooter extends connect(store)(LitElement) {

	static styles = css`

	.footer {
		bottom: 0px;
		position: absolute;
	}

	.footer p {
		font: var(--font-specsheet-print-small-light);
	}

	.footer span {
		font: var(--font-specsheet-print-small-bold);
	}

	`;
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.price = state.price.data.totalPriceInEuro;
	}
	render() {
		const s = this.state;
		const date = new Date();
		const currentDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

		return html`
		<div class="footer">
			<p>
				<span>Selux GmbH, Volkmarstraße 18, D-12099 Berlin, T +49 30 72001-0, F -100, info@selux.de, www.selux.com</span>
				<span class="price">${this.price}</span>
				<span class="date">${currentDate}</span>
			</p>
		</div>
		`;
	}
}
